const LAST_NUT_PASSWORD = {
  salt: 'n/p43yae6o8IWK2thul+3g==',
  expectedHash: 'tebTzTSOnISmBNOD1TAwUQkZSjXhYcw1VmW3W0FwT9w=',
  iterations: 600000,
};

function decodeBase64(value) {
  return Uint8Array.from(window.atob(value), (character) => character.charCodeAt(0));
}

function hashesMatch(candidate, expected) {
  if (candidate.length !== expected.length) return false;

  let difference = 0;
  for (let index = 0; index < candidate.length; index += 1) {
    difference |= candidate[index] ^ expected[index];
  }
  return difference === 0;
}

export async function verifyPassword(password, config, subtle = window.crypto?.subtle) {
  if (typeof password !== 'string' || !password || !subtle) return false;

  const key = await subtle.importKey(
    'raw',
    new TextEncoder().encode(password),
    { name: 'PBKDF2' },
    false,
    ['deriveBits']
  );
  const derivedBits = await subtle.deriveBits(
    {
      name: 'PBKDF2',
      hash: 'SHA-256',
      salt: decodeBase64(config.salt),
      iterations: config.iterations,
    },
    key,
    256
  );

  return hashesMatch(new Uint8Array(derivedBits), decodeBase64(config.expectedHash));
}

export function verifyLastNutPassword(password) {
  return verifyPassword(password, LAST_NUT_PASSWORD);
}
